import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import { getReport } from 'App/services/ReportEngineService';
import { queryClient } from 'Shared/queryClient';

const propTypes = {
    look: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        title: PropTypes.string.isRequired,
    }).isRequired,
};

const defaultProps = {};

function loadLook(id) {
    return getReport('look', id).then((res) => {
        queryClient.setQueryData(['insights', 'embedUrl'], res);
    });
}

function LookButton({ look }) {
    return (
        <Button key={look.id} variant="link" onClick={() => loadLook(look.id)}>
            {look.title}
        </Button>
    );
}

LookButton.propTypes = propTypes;
LookButton.defaultProps = defaultProps;

export default LookButton;
